import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { QRCodeSVG } from 'qrcode.react'
import SingEvent from '../../assets/img/sing-event.png'
import Clinet from '../../assets/img/clinet.png'
import Vs from '../../assets/img/vs.png'
import Calendar from '../../assets/img/calendar.png'
import {
  EMPTY_OBJECT, EVENT_TYPES,
} from '../../constants/globalConstants'
import {
  dateFormatter,
  formatAMPM,
  formatDateDays,
  //getEventImageById,
  getEventType,
  getImage,
} from '../../utils/helper'

function NormalTicket(props) {
  
  //const { eventId, eventType, paymentResponse} = props
  const {eventType, paymentResponse} = props

if(paymentResponse?.mapco_qrcode.length > 0){
  return(
    paymentResponse?.mapco_qrcode?.map((qrcodeData, i) => {
      {
        if(qrcodeData?.event != null){
        return (
          <div className="row justify-content-center" key={i}>
            <div className="col-12 col-md-10">
              <div className="card  border-danger shadow mb-3">
                <div className="card-body p-4">
                  <div className="row g-5">
                    <div className="col-sm-3 d-none d-sm-block col-12">
                    <div className='centerImage img-thumbnail shadow'>
                      <img
                      
              src={getImage(paymentResponse?.rates)}
                        //src={getEventImageById(eventId)}
                      />
                      </div>
                    </div>
                    <div className="col">
                      <div className="row g-0 align-items-end mt-4">
                        <div className="col text-center">
                          <img src={Clinet} width="150px" className="img-fluid" />
                          <p className="nowrap">Rochester Americans</p>
                        </div>
                        <div className="col-auto">
                          <img src={Vs} className="img-fluid" width="100px" />
                        </div>
                        <div className="col text-center">
                          {/* <img src={Comp} width="60px" className="img-fluid" /> */}
                          <img
              src={getImage(qrcodeData?.event)}
                          //   src={
                          //     process.env.PUBLIC_URL +
                          //     '/game-icons/' +
                          //     qrcodeData?.event?.slug?.replace(/ /g, '') +
                          //     '.png'
                          //   }
                            width="150px"
                            className="img-fluid"
                          />
                          <p className="nowrap"> {qrcodeData?.event?.slug}</p>
                        </div>
                      </div>
                      <div className="border rounded text-center mt-2 p-3">
                        <div className='row justify-content-center align-items-center'>
                          <div className='col-auto'>
                             <img src={Calendar} width="35" />
                          </div>
                          <div className='col-auto'>
                          {dateFormatter(
                          qrcodeData?.event?.start_time,
                          'MMMM DD, YYYY'
                        )}
                            , {formatDateDays(qrcodeData?.event?.start_time)}
                           &nbsp;&nbsp;<br className='d-block d-sm-none'/> {formatAMPM(qrcodeData?.event?.start_time)}
                          </div><br/>
                          {qrcodeData?.event?.parking_time_message ? <div className='col-auto'>
                           <small className='d-block lh-sm'>{qrcodeData?.event?.parking_time_message}</small>
                          </div> : null}
                        </div>
                       
                        
                      </div>
                      <div className="row">
                        {/* <div className="col">
                          <small>Total 2 Entires Allowed</small>
                        </div>
                        <div className="col text-end">
                          <small>
                            {' '}
                            <Link to={URL.HOME}>
                              {' '}
                              Click here to add to calendar{' '}
                            </Link>
                          </small>
                        </div> */}
                      </div>
                      <h4 className=" mt-3 fw-bold text-center">
                        {/* {getEventType(eventType)} */}
                        {eventType == EVENT_TYPES?.EVENT
                          ? getEventType(eventType)
                          : paymentResponse?.rates?.description}
                      </h4>
                    </div>
                    <div className="col-sm-3 d-block d-sm-none col-12">
                      <img
                        className="w-100 img-thumbnail shadow"
                        src={SingEvent}
                      />
                    </div>
  
                    <div className="col-sm-3 ps-sm-0 col-12">
                      <div className="p-2 bg-danger rounded">
                        <div className="bg-white p-2">
                          <div id="responsive-canvas">
                            {qrcodeData && (
                              <QRCodeSVG
                                value={qrcodeData?.qrcode}
                                width="100%"
                                height="100%"
                                // size={180}
                              />
                            )}
                            <span className='d-flex justify-content-center mt-2'><b>{qrcodeData?.qrcode}</b></span>
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center justify-content-center text-white">
                          <p className="mt-2">Total Paid : </p>
                          <h3 className="mt-2">
                            ${paymentResponse.total}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      }
    })
  )
} else{
  return  <div className="row justify-content-center">
              <div className="col-12 col-md-10">
                <div className="card  border-danger shadow mb-3">
                  <div className="card-body p-4">
                    <div className="row g-5">
                      <div className="col-sm-3 d-none d-sm-block col-12">
                        <h3>No QR Code generated, Please contact to our customer support for the same</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
}
  
}
NormalTicket.propTypes = {
    dispatch: PropTypes.func,
	data: PropTypes.object,
    eventId: PropTypes.string, 
    eventType: PropTypes.string, 
    paymentResponse: PropTypes.object
}

NormalTicket.defaulProps = {
    dispatch: noop,
	data: EMPTY_OBJECT,
    eventId:undefined, 
    eventType:undefined, 
    paymentResponse: EMPTY_OBJECT
}

function mapStateToProps({ peymentReducer }) {
  return {
    data: peymentReducer,
  }
}
export default connect(mapStateToProps)(NormalTicket)
